import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs'
class ProductCollectionFilter extends HTMLElement {
    constructor() {
        super();

        // declare variables
        this.filters = this.querySelectorAll('a[data-type]');

        this.parent = this.closest('.section');

        this.productCards = this.parent.querySelectorAll('.product-card');
    }

    connectedCallback() {

        //  add event listener to each filter
        this.filters.forEach(filter => {
            filter.addEventListener('click', (e) => {
                e.preventDefault();

                if (filter.dataset.type === 'all') {
                    this._removeFilterActiveClass();
                    this.productCards.forEach(card => {
                        card.style.display = 'block';
                    });
                    filter.classList.add('active');
                    return;
                }

                if (filter.classList.contains('active')) {
                    this._removeFilterActiveClass();
                    this.productCards.forEach(card => {
                        card.style.display = 'block';
                    });
                    return;
                }

                this._removeFilterActiveClass();
                filter.classList.add('active');
                // filter all product cards and match it width its data attribute data-product-type
                this.productCards.forEach(card => {
                    if (card.dataset.productType === filter.dataset.type) {
                        card.style.display = 'block';
                    } else {
                        card.style.display = 'none';
                    }
                }
                );
            });
        });
    }

    _removeFilterActiveClass() {
        this.filters.forEach(filter => {
            filter.classList.remove('active');
        });
    }
} 

import { animate as motionAnimate, timeline as motionTimeline } from "vendor";
class ChangeFrequencyPopup extends HTMLElement {
    constructor() {
        super();

        this.frequencyAnswerKey = {
            "less-than-5-times-a-week-1-person-clear": {
              "text": "2 MILO Filters / 3 months",
              "price": "199 kr/filter",
              "description": "The selected number of filters will be delivered every 2 months.",
              "qty": 2,
              "sellingPlanId": "692725711145"
            },
            "less-than-5-times-a-week-1-person-slightly-dirty": {
              "text": "3 MILO Filters / 3 months",
              "price": "199 kr/filter",
              "description": "The selected number of filters will be delivered every 3 months.",
              "qty": 3,
              "sellingPlanId": "692725711145"
            },
            "less-than-5-times-a-week-1-person-murky": {
              "text": "4 MILO Filters / 3 months",
              "price": "199 kr/filter",
              "description": "The selected number of filters will be delivered every 2 months.",
              "qty": 4,
              "sellingPlanId": "692725711145"
            },
            "less-than-5-times-a-week-1-person-very-dirty": {
              "text": "6 MILO Filters / 2 months",
              "price": "199 kr/filter",
              "description": "The selected number of filters will be delivered every 1 month",
              "qty": 6,
              "sellingPlanId": "692725711145"
            },
            "less-than-5-times-a-week-1-person-unusable": {
              "text": "8 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "The selected number of filters will be delivered every 1 month",
              "qty": 8,
              "sellingPlanId": "692725711145"
            },
            "less-than-5-times-a-week-2-persons-clear": {
              "text": "3 MILO Filters / 3 months",
              "price": "199 kr/filter",
              "description": "The selected number of filters will be delivered every 3 months.",
              "qty": 3,
              "sellingPlanId": "692725711145"
            },
            "less-than-5-times-a-week-2-persons-slightly-dirty": {
              "text": "4 MILO Filters / 3 months",
              "price": "199 kr/filter",
              "description": "The selected number of filters will be delivered every 2 months.",
              "qty": 4,
              "sellingPlanId": "692725711145"
            },
            "less-than-5-times-a-week-2-persons-murky": {
              "text": "6 MILO Filters / 2 months",
              "price": "199 kr/filter",
              "description": "The selected number of filters will be delivered every 1 month.",
              "qty": 6,
              "sellingPlanId": "692725711145"
            },
            "less-than-5-times-a-week-2-persons-very-dirty": {
              "text": "8 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "The selected number of filters will be delivered every 1 month.",
              "qty": 8,
              "sellingPlanId": "692725711145"
            },
            "less-than-5-times-a-week-2-persons-unusable": {
              "text": "10 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "The selected number of filters will be delivered every 1 month.",
              "qty": 10,
              "sellingPlanId": "692725711145"
            },
            "less-than-5-times-a-week-3-persons-clear": {
              "text": "4 MILO Filters / 3 months",
              "price": "199 kr/filter",
              "description": "The selected number of filters will be delivered every 2 months.",
              "qty": 4,
              "sellingPlanId": "692725711145"
            },
            "less-than-5-times-a-week-3-persons-slightly-dirty": {
              "text": "6 MILO Filters / 2 months",
              "price": "199 kr/filter",
              "description": "The selected number of filters will be delivered every 1 month.",
              "qty": 6,
              "sellingPlanId": "692725711145"
            },
            "less-than-5-times-a-week-3-persons-murky": {
              "text": "8 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "The selected number of filters will be delivered every 1 month.",
              "qty": 8,
              "sellingPlanId": "692725711145"
            },
            "less-than-5-times-a-week-3-persons-very-dirty": {
              "text": "10 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "The selected number of filters will be delivered every 1 month.",
              "qty": 10,
              "sellingPlanId": "692725711145"
            },
            "less-than-5-times-a-week-3-persons-unusable": {
              "text": "12 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "The selected number of filters will be delivered every 1 month.",
              "qty": 12,
              "sellingPlanId": "692725711145"
            },
            "5-7-times-a-week-1-person-clear": {
              "text": "4 MILO Filters / 2 months",
              "price": "199 kr/filter",
              "description": "Delivered every 2 months.",
              "qty": 4,
              "sellingPlanId": "692725711145"
            },
            "5-7-times-a-week-1-person-slightly-dirty": {
              "text": "5 MILO Filters / 2 months",
              "price": "199 kr/filter",
              "description": "Delivered every 2 months.",
              "qty": 5,
              "sellingPlanId": "692725711145"
            },
            "5-7-times-a-week-1-person-murky": {
              "text": "6 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 6,
              "sellingPlanId": "692725711145"
            },
            "5-7-times-a-week-1-person-very-dirty": {
              "text": "8 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 8,
              "sellingPlanId": "692725711145"
            },
            "5-7-times-a-week-1-person-unusable": {
              "text": "10 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 10,
              "sellingPlanId": "692725711145"
            },
            "5-7-times-a-week-2-persons-clear": {
              "text": "5 MILO Filters / 2 months",
              "price": "199 kr/filter",
              "description": "Delivered every 2 months.",
              "qty": 5,
              "sellingPlanId": "692725711145"
            },
            "5-7-times-a-week-2-persons-slightly-dirty": {
              "text": "6 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 6,
              "sellingPlanId": "692725711145"
            },
            "5-7-times-a-week-2-persons-murky": {
              "text": "8 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 8,
              "sellingPlanId": "692725711145"
            },
            "5-7-times-a-week-2-persons-very-dirty": {
              "text": "10 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 10,
              "sellingPlanId": "692725711145"
            },
            "5-7-times-a-week-2-persons-unusable": {
              "text": "12 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 12,
              "sellingPlanId": "692725711145"
            },
            "5-7-times-a-week-3-persons-clear": {
              "text": "6 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 6,
              "sellingPlanId": "692725711145"
            },
            "5-7-times-a-week-3-persons-slightly-dirty": {
              "text": "8 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 8,
              "sellingPlanId": "692725711145"
            },
            "5-7-times-a-week-3-persons-murky": {
              "text": "10 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 10,
              "sellingPlanId": "692725711145"
            },
            "5-7-times-a-week-3-persons-very-dirty": {
              "text": "12 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 12,
              "sellingPlanId": "692725711145"
            },
            "5-7-times-a-week-3-persons-unusable": {
              "text": "14 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 14,
              "sellingPlanId": "692725711145"
            },
            "more-than-once-a-day-1-person-clear": {
              "text": "5 MILO Filters / 2 months",
              "price": "199 kr/filter",
              "description": "Delivered every 2 months.",
              "qty": 5,
              "sellingPlanId": "692725711145"
            },
            "more-than-once-a-day-1-person-slightly-dirty": {
              "text": "6 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 6,
              "sellingPlanId": "692725711145"
            },
            "more-than-once-a-day-1-person-murky": {
              "text": "8 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 8,
              "sellingPlanId": "692725711145"
            },
            "more-than-once-a-day-1-person-very-dirty": {
              "text": "10 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 10,
              "sellingPlanId": "692725711145"
            },
            "more-than-once-a-day-1-person-unusable": {
              "text": "12 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 12,
              "sellingPlanId": "692725711145"
            },
            "more-than-once-a-day-2-persons-clear": {
              "text": "6 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 6,
              "sellingPlanId": "692725711145"
            },
            "more-than-once-a-day-2-persons-slightly-dirty": {
              "text": "8 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 8,
              "sellingPlanId": "692725711145"
            },
            "more-than-once-a-day-2-persons-murky": {
              "text": "10 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 10,
              "sellingPlanId": "692725711145"
            },
            "more-than-once-a-day-2-persons-very-dirty": {
              "text": "12 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 12,
              "sellingPlanId": "692725711145"
            },
            "more-than-once-a-day-2-persons-unusable": {
              "text": "14 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 14,
              "sellingPlanId": "692725711145"
            },
            "more-than-once-a-day-3-persons-clear": {
              "text": "8 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 8,
              "sellingPlanId": "692725711145"
            },
            "more-than-once-a-day-3-persons-slightly-dirty": {
              "text": "10 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 10,
              "sellingPlanId": "692725711145"
            },
            "more-than-once-a-day-3-persons-murky": {
              "text": "12 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 12,
              "sellingPlanId": "692725711145"
            },
            "more-than-once-a-day-3-persons-very-dirty": {
              "text": "14 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 14,
              "sellingPlanId": "692725711145"
            },
            "more-than-once-a-day-3-persons-unusable": {
              "text": "16 MILO Filters / 1 month",
              "price": "199 kr/filter",
              "description": "Delivered every 1 month.",
              "qty": 16,
              "sellingPlanId": "692725711145"
            }
        }

        this.activePage = 1;

        // declare variables
        this.closeBtn = this.querySelector('[data-close-popup]');
        this.backBtn = this.querySelector('[data-back-popup]');
        this.blankSlate = this.querySelector('[data-blank-slate]');
        this.popupContent = this.querySelector('[data-popup-content]');
        this.frequencyOption = this.querySelectorAll('[data-frequency-option]');
        this.frequencyMonthsOption = this.querySelector('#frequency');

        this.feildsetRadio = this.querySelectorAll('[data-customize-radio]');
        this.fieldsetSelect = this.querySelectorAll('[data-customize-select]');

        this.continueShoppingBtn = this.querySelector('[data-continue-shopping]');
        this.needHelpBtn = this.querySelector('[data-need-help]');
        this.getResultsBtn = this.querySelector('[data-get-results]');
        this.customizeSkipBtn = this.querySelector('[data-customize-skip]');

        this.CustomProductOptions = document.querySelector('custom-product-options');
        this.CustomProductOptionsSubscribeOneTime = document.querySelector('custom-product-options-subscribe-one-time');
    }

    connectedCallback() {

        this.frequencyOption.forEach(option => {
            option.addEventListener('click', (e) => {
                e.preventDefault();

                // remove active class from all options
                this.frequencyOption.forEach(option => {
                    option.classList.remove('active');
                });
                // add active class to the clicked option
                option.classList.add('active');

                // get the data attribute of the clicked option
                const qty = Number(option.dataset.qty);
                // const customOptionQty = this.CustomProductOptions._getSelectedOption().dataset.qtyValue;

                // update form qty
                this.CustomProductOptions?._updateQty(qty);
                this.CustomProductOptionsSubscribeOneTime?.updateQty(qty);

                const { frequency, activeOption } = this._getSelectedFrequencyOption();

                // update change frequency button text
                this.CustomProductOptions?.updateChangeFrequencyBtnText(`${activeOption.dataset.frequencyOptionText} | every ${frequency} months`);
                // update change frequency button text
                this.CustomProductOptionsSubscribeOneTime?.updateChangeFrequencyBtnText(`${activeOption.dataset.frequencyOptionText} | every ${frequency} months`);
            })
        })

        // add event listener to close button
        this.closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this._hide();
        });

        this.customizeSkipBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this._hide();
        });

        this.backBtn.addEventListener('click', (e) => {
            e.preventDefault();
            if (this.activePage > 1) {
                this.activePage--;
            }
            // execute custom event
            this.dispatchEvent(new CustomEvent('change-page'));
        });

        this.continueShoppingBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this._hide();
        });

        this.needHelpBtn.addEventListener('click', (e) => {
            e.preventDefault();
            if (this.activePage < 3) {
                this.activePage++;
            }

            // execute custom event
            this.dispatchEvent(new CustomEvent('change-page'));
        });

        this.getResultsBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this._setCustomizeOptionResults();

            if (this.activePage < 3) {
                this.activePage++;
            }
            // execute custom event
            this.dispatchEvent(new CustomEvent('change-page'));
        });

        // add event listener to outside click
        this.blankSlate.addEventListener('click', (e) => {
            e.preventDefault();
            this._hide();
        });

        // add event listener to frequency customize questions
        this.feildsetRadio.forEach(fieldset => {
            fieldset.addEventListener('change', () => {
                // get the selected option
                const selectedOption = fieldset.querySelector('input:checked');
                const selectedOptionValue = selectedOption.value;
                console.log('Selected option: ', selectedOptionValue);
            })
        });

        this.fieldsetSelect.forEach(fieldset => {
            fieldset.addEventListener('change', () => {
                // get the selected option
                const selectedOption = fieldset.querySelector('select');
                const selectedOptionValue = selectedOption.value;
                console.log('Selected option: ', selectedOptionValue);
            })
        });

        this.frequencyMonthsOption.addEventListener('change', (e) => {
            const { frequency, activeOption } = this._getSelectedFrequencyOption();

            // update change frequency button text
            this.CustomProductOptions.updateChangeFrequencyBtnText(`${activeOption.dataset.frequencyOptionText} | every ${frequency} months`);
        });

        // add event listener to escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this._hide();
            }
        });

        // check if active page is 0 else show back button
        if (this.activePage === 1) {
            this.backBtn.classList.add('visibility-hidden');
        } else {
            this.backBtn.classList.remove('visibility-hidden');
        }

        // add event listener to catch change-page event
        this.addEventListener('change-page', (e) => {
            console.log('change page event triggered', this.activePage);
            if (this.activePage === 1) {
                this.backBtn.classList.add('visibility-hidden');
            } else {
                this.backBtn.classList.remove('visibility-hidden');
            }
            console.log('active page: ', this.activePage);
            // show the active page
            this.querySelectorAll('[data-page]').forEach(page => {
                if (page.dataset.page == this.activePage) {
                    page.classList.remove('hidden');
                } else {
                    page.classList.add('hidden');
                }
            });
        });
    }

    _getSelectedFrequencyOption() {
      const selectedFrequency = this.frequencyMonthsOption.value;
      const activeOption = this.querySelector('[data-frequency-option].active');

      return {
        frequency: selectedFrequency,
        activeOption: activeOption
      }
    }

    _show() {
        document.querySelector('body').style.overflow = 'hidden';
        this.style.display = 'block';
        this.popupContent.animate([
            { clipPath: 'inset(0 0 0 100% round var(--rounded-sm))' }, // Hidden from left
            { clipPath: 'inset(0 0 0 0 round var(--rounded-sm))' }     // Fully visible
          ], {
            duration: 300,
            easing: 'ease-out',
            fill: 'forwards' // Keeps the final state
          }).finished.then(() => {
            this.popupContent.querySelectorAll('[data-page]').forEach(page => {
                page.style.opacity = 1;
            })
          });
    }

    _hide() {
        this.popupContent.querySelectorAll('[data-page]').forEach(page => {
            page.style.opacity = 0;
        })
        this.popupContent.animate([
            { clipPath: 'inset(0 0 0 0 round var(--rounded-sm))' },     // Fully visible
            { clipPath: 'inset(0 0 0 100% round var(--rounded-sm))' } // Hidden from left
          ], {
            duration: 300,
            easing: 'ease-out',
            fill: 'forwards' // Keeps the final state
          }).finished.then(() => {
              this.style.display = 'none';
              document.querySelector('body').style.overflow = 'auto';
          });
    }

    _setCustomizeOptionResults() {
        var selectedOptionAnswerKey = "";

        this.feildsetRadio.forEach(fieldset => {
            const selectedOption = fieldset.querySelector('input:checked');
            const selectedOptionValue = selectedOption.value.toLowerCase();
            if (selectedOptionAnswerKey === "") {
                selectedOptionAnswerKey = selectedOptionValue;
            } else {
                selectedOptionAnswerKey = selectedOptionAnswerKey + "-" + selectedOptionValue;
            }
        });

        this.fieldsetSelect.forEach(fieldset => {
            const selectedOption = fieldset.querySelector('select');
            const selectedOptionValue = selectedOption.value.toLowerCase();
            if (selectedOptionAnswerKey === "") {
                selectedOptionAnswerKey = selectedOptionValue;
            } else {
                selectedOptionAnswerKey = selectedOptionAnswerKey + "-" + selectedOptionValue;
            }
        });

        const text = this.querySelector('[data-customize-text]');
        const price = this.querySelector('[data-customize-price]');
        const description = this.querySelector('[data-customize-description]');

        const key = this.frequencyAnswerKey[selectedOptionAnswerKey];

        if (key) {
            text.innerHTML = key.text;
            price.innerHTML = key.price;
            description.innerHTML = key.description;
        }

        console.log("Selected option: ", selectedOptionAnswerKey);
    }
}

class CustomProductOptions extends HTMLElement {
    constructor() {
        super();

        this.mode = 'subscription';
        this.productType = this.getAttribute('data-product-type');

        this.subscriptionFilterId = null;
        this.defaultFilterId = null;

        // declare variables
        this.options = this.querySelectorAll('[data-option-item]');

        this.changeFrequencyBtn = this.querySelector('[data-change-frequency]');

        this.changeModeBtn = this.querySelector('[data-option-mode]');

        this.formInputFilter = document.querySelector('[data-form-filter-id]');
        this.formInputShowerhead = document.querySelector('[data-form-showerhead-id]');
        this.formInputShowerheadQty = document.querySelector('[data-form-showerhead-qty]');
        this.formInputFilterQty = document.querySelector('[data-form-filter-qty]');
        this.formInputFilterSellingPlan = document.querySelector('[data-form-selling-plan-id]');
        this.formAddToCartBtns = document.querySelectorAll('[data-pdp-cart-button]');

        // Change frequency popup
        this.changeFrequencyPopup = document.querySelector('change-frequency-popup');

        if (this.productType != 'showerhead') {
          this.mode = 'one-time-purchased';
        }
    }

    connectedCallback() {
        // set default value to form input
        this._updateAddToCartBtn();

        // add event listener to each option
        this.options.forEach(option => {
            option.addEventListener('click', (e) => {
                e.preventDefault();
                // remove active class from all options
                this._removeActiveClass();
                // add active class to the clicked option
                option.classList.add('active');

                // get the data attribute of the clicked option
                const qty = option.dataset.qtyValue;

                // set the value of the form input to the data attribute of the clicked option
                this._updateQty(qty);
                this._updateAddToCartBtn();
            })
        })

        // add event listener to change frequency button
        this.changeFrequencyBtn?.addEventListener('click', (e) => {
            
            this.changeFrequencyPopup._show();
        })

        this.changeModeBtn?.addEventListener('click', (e) => {
            e.preventDefault();
            this.mode = this.mode === 'subscription' ? 'one-time-purchased' : 'subscription';
            let modeText = this.mode === 'subscription' ?  e.target.dataset.defaultPrice : e.target.dataset.subscriptionPrice;

            if (this.mode === 'subscription') {
                const subscriptionFilterId = e.target.dataset.subscriptionFilterId;
                const subscriptionShowerheadId = e.target.dataset.subscriptionShowerheadId;

                this.formInputShowerhead.value = subscriptionShowerheadId;
                this.formInputFilter.value = subscriptionFilterId;

                // enable selling plan input
                this.formInputFilterSellingPlan.disabled = false;
                // enable filter id and quantity
                this.formInputFilter.disabled = false;
                this.formInputFilterQty.disabled = false;

                // set qty to selected option
                const selectedOption = this._getSelectedOption();
                this._updateQty(selectedOption.dataset.qtyValue);

                // show filter frequency box
                this.querySelector('[data-filter-frequency-container]').style.display = 'block';

                this._showOptions("subscription");
            } else {

                // disabled filter id and quantity
                this.formInputFilter.disabled = true;
                this.formInputFilterQty.disabled = true;
                const defaultFilterId = e.target.dataset.filterId;
                const defaultShowerheadId = e.target.dataset.showerheadId;

                this.formInputFilter.value = defaultFilterId;
                this.formInputShowerhead.value = defaultShowerheadId;

                // disable selling plan input
                this.formInputFilterSellingPlan.disabled = true;

                // set qty to selected option
                const selectedOption = this._getSelectedOption();
                this.formInputFilterQty.value = selectedOption.dataset.qtyValue;
                if (this.formInputShowerheadQty) {
                  this.formInputShowerheadQty.value = selectedOption.dataset.qtyValue;
                }

                // hide filter frequency box
                this.querySelector('[data-filter-frequency-container]').style.display = 'none';
                this._showOptions("one-time-purchased");
                
            }

            this.changeModeBtn.innerText = modeText;
            this._updateAddToCartBtn();
        })

        
        document.addEventListener('variant:change', () => {
          this._updateAddToCartBtn();
        });

    }

    _removeActiveClass() {
        this.options.forEach(option => {
            // match the mode
            if (option.dataset.mode === this.mode) {
                option.classList.remove('active');
            }
        });
    }

    _getSelectedOption() {
        let selectedOption = null;
        this.options.forEach(option => {
            if (option.classList.contains('active') && option.dataset.mode === this.mode) {
                // set the selected option to the clicked option
                selectedOption = option;
            }
        });
        return selectedOption;
    }

    _updateQty(filterQty, showerheadQty = this._getSelectedOption().dataset.qtyValue) {

      if (this.productType == 'bulk') {
        this.inputQty = document.querySelector('[data-form-filter-qty]');
        // showerheadQty is used also as variable name for other products
        this.inputQty.value = showerheadQty;
      } else {
        if (!this.formInputFilterQty || !this.formInputShowerheadQty) return;
        this.formInputShowerheadQty.value = showerheadQty;
        this.formInputFilterQty.value = filterQty;
      }
    }

    _showOptions(mode) {
        this.options.forEach(option => {
            if (option.dataset.mode === mode) {
                option.classList.remove('hidden');
            } else {
                option.classList.add('hidden');
            }
        });
    }

    _updateAddToCartBtn() {
        const currentActiveOption = this._getSelectedOption();
        if (!currentActiveOption) return;

        const formAddToCartBtns = document.querySelectorAll('[data-pdp-cart-button]');
        const price = currentActiveOption.querySelector('[data-price]')?.innerHTML;
        const comparedPrice = currentActiveOption.querySelector('[data-compared-price]')?.innerHTML || '';
        formAddToCartBtns.forEach(btn => {
            const context = btn.dataset.context;
            console.log("context: ", btn);
            // if (context && context === 'cart-drawer') {
            //   return
            // }
            const btnOriginalText = btn.dataset.originalText;
            const btnContainer = btn.querySelector('div');
            btnContainer.innerHTML  = `${btnOriginalText} &nbsp;•&nbsp; ${price} &nbsp;<span class="line-through">${comparedPrice}</span>`;

            btn.setAttribute('data-custom-price', `${btnOriginalText} &nbsp;•&nbsp; ${price} &nbsp;`);
        })
    }

    getMode() {
      return this.mode;
    }

    updateChangeFrequencyBtnText(text) {
      if (this.changeFrequencyBtn) {
        const btnText = this.changeFrequencyBtn.querySelector('span');
        btnText.innerHTML = text;
      }
    }
}

class CustomProductOptionsSubscribeOneTime extends HTMLElement {
  constructor() {
    super();
    // declare variables
    this.options = this.querySelectorAll('[data-option-item]');

    this.changeFrequencyBtn = this.querySelector('[data-change-frequency]');

    // Change frequency popup
    this.changeFrequencyPopup = document.querySelector('change-frequency-popup');
  }

  connectedCallback() {
    // set default value to form input
    this._updateAddToCartBtn();

    // add event listener to each option
    this.options.forEach(option => {
        option.addEventListener('click', (e) => {
          e.preventDefault();
          // remove active class from all options
          this._removeActiveClass();
          // add active class to the clicked option
          option.classList.add('active');

          // get the data attribute of the clicked option
          const qty = option.dataset.qtyValue;
          window.productOptionMode = option.dataset.mode;

          console.log("Selected option mode: ", window.productOptionMode);

          // set the value of the form input to the data attribute of the clicked option
          this.updateQty(qty);
          this._updateAddToCartBtn();
          this._updateProductFormInputs();
        })
    })

    // add event listener to change frequency button
    this.changeFrequencyBtn?.addEventListener('click', (e) => {
      this.changeFrequencyPopup._show();
    })

    document.addEventListener('variant:change', () => {
      this._updateAddToCartBtn();
    });
  }

  _getSelectedOption() {
    let selectedOption = null;
    this.options.forEach(option => {
      if (option.classList.contains('active')) {
        // set the selected option to the clicked option
        selectedOption = option;
        window.productOptionMode = option.dataset.mode;
      }
    });
    return selectedOption;
  }

  updateQty(filterQty) {
    const formInputFilterQty = document.querySelector('[data-form-filter-qty]');
    formInputFilterQty.value = filterQty;
  }

  updateChangeFrequencyBtnText(text) {
    if (this.changeFrequencyBtn) {
      const btnText = this.changeFrequencyBtn.querySelector('span');
      btnText.innerHTML = text;
    }
  }

  _removeActiveClass() {
    this.options.forEach(option => {
      // match the mode
      option.classList.remove('active');
    });
  }

  _updateAddToCartBtn() {
    const currentActiveOption = this._getSelectedOption();
    console.log("Updating add to cart button...", currentActiveOption);
    if (!currentActiveOption) return;

    const formAddToCartBtns = document.querySelectorAll('[data-pdp-cart-button]');
    const price = currentActiveOption.querySelector('[data-price]')?.innerHTML;
    const comparedPrice = currentActiveOption.querySelector('[data-compared-price]')?.innerHTML || '';
    formAddToCartBtns.forEach(btn => {
        const context = btn.dataset.context;
        console.log("context: ", btn);
        // if (context && context === 'cart-drawer') {
        //   return
        // }
        const btnOriginalText = btn.dataset.originalText;
        const btnContainer = btn.querySelector('div');
        btnContainer.innerHTML  = `${btnOriginalText} • ${price} <span class="line-through">${comparedPrice}</span>`;

        btn.setAttribute('data-custom-price', `${btnOriginalText} • ${price}`);
    })
  }

  _updateProductFormInputs() {
    const formInputFilter = document.querySelector('[data-form-filter-id]');
    const formInputShowerhead = document.querySelector('[data-form-showerhead-id]');
    const formInputShowerheadQty = document.querySelector('[data-form-showerhead-qty]');
    const formInputFilterQty = document.querySelector('[data-form-filter-qty]');
    const formInputFilterSellingPlan = document.querySelector('[data-form-selling-plan-id]');
    
    const mode = window.productOptionMode;

    const selectedOption = this._getSelectedOption();
    if(mode === 'subscription') {
      // enable selling plan input
      formInputFilterSellingPlan.disabled = false;
      // enable filter id and quantity
      formInputFilter.disabled = false;
      formInputFilterQty.disabled = false;

      formInputShowerhead.value = window.selectedSubsVariantId || selectedOption.dataset.productId;
    } else {
      // disabled filter id and quantity
      formInputFilterSellingPlan.disabled = true;
      formInputFilter.disabled = true;
      formInputFilterQty.disabled = true;
      formInputShowerhead.value = window.selectedVariantId || selectedOption.dataset.productId;
    }

    // set qty to selected option
    this.updateQty(selectedOption.dataset.qtyValue);
  }
}

class CustomImageWithGrid extends HTMLElement {
  constructor() {
    super();

    // declare variables
    this.cardButtons = this.querySelectorAll('[data-card-button]');
    this.cardListPopup = document.querySelector('card-list-popup');
    this.cardListOptionButtons = this.querySelectorAll('[data-button-id]');

  }

  connectedCallback() {
    // add event listener to each card button
    this.cardButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const cardContent = button.querySelector('[data-card-list-popup-content]');
        const carouselContent = button.querySelector('[data-carousel-content]');
        // get the title of the carousel from data attribute carousel-title
        const carouselTitle = carouselContent.dataset.carouselTitle;
        // update card list popup content
        this.cardListPopup.updateContent(cardContent.innerHTML);
        this.cardListPopup.updateCarouselContent(carouselContent.innerHTML);
        this.cardListPopup.updateCarouselTitle(carouselTitle);
        // show card list popup
        this.cardListPopup._show();
      });
    });

    this.cardListOptionButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();

        // remove active class from all buttons
        this.cardListOptionButtons.forEach(btn => {
          btn.classList.remove('active');
        });

        // add active class to the clicked button
        button.classList.add('active');

        // get this button id
        const buttonId = button.dataset.buttonId;

        // update card active list
        this._updateActiveCardList(buttonId);
      })
    });

    // initialize card list
    this._initCardList();
  }

  _updateActiveCardList(buttonId) {
    // hide all card buttons
    this.cardButtons.forEach(button => {
      const cardId = button.dataset.cardId;
      console.log('card id: ', cardId);
      console.log('button id: ', buttonId);
      if (cardId === buttonId) {
        button.style.display = 'flex';
      } else {
        button.style.display = 'none';
      }
    });

    // remove class first-item from all card buttons
    this.cardButtons.forEach(button => {
      button.classList.remove('first-item');
    });

    // add class first-item to the card list that is the first iten which is not set to display none.
    const firstVisibleCardButton = Array.from(this.cardButtons).find(button => {
      return window.getComputedStyle(button).display !== 'none';
    })

    if (firstVisibleCardButton) {
      firstVisibleCardButton.classList.add('first-item');
    }

    const lastVisibleCardButton = Array.from(this.cardButtons).reverse().find(button => {
      return window.getComputedStyle(button).display !== 'none';
    })
    
    if (lastVisibleCardButton) {
      lastVisibleCardButton.style.borderBottomColor = 'transparent';
    }

  }

  _initCardList() {
    // get cardListOptionButtons that has a class of active
    const activeButton = this.querySelector('[data-button-id].active');

    if (activeButton) {
      const buttonId = activeButton.dataset.buttonId;
      // update card active list
      this._updateActiveCardList(buttonId);
    }

  }
}

class CustomInstallationCard extends HTMLElement {
  constructor() {
    super();

    this.openVideoBtn = this.querySelector('[data-open-video]');
    this.swiperContainer = this.querySelector('[data-swiper-container]');

    this.installationPopup = document.querySelector('installation-popup');

  }

  connectedCallback() {
    if (this.openVideoBtn) {
      this.openVideoBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.installationPopup.show();
      });
    }

    this.swiper = new Swiper(this.swiperContainer, {
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        nextEl: this.querySelector('[data-swiper-button-next]'),
        prevEl: this.querySelector('[data-swiper-button-prev]'),
      },
      pagination: {
        el: this.querySelector('[data-swiper-pagination]'),
        clickable: true,
      },
    });
  }
}
class CustomPhotoGallery extends HTMLElement {
  constructor() {
    super();

    this.openVideoBtn = this.querySelector('[data-open-video]');
    this.readMoreBtns = this.querySelectorAll('[data-read-more]');
    this.swiperContainer = this.querySelector('[data-swiper-container]');
    this.cardItems = this.querySelectorAll('[data-card-item]');

    this.photoGalleryPopup = document.querySelector('photo-gallery-popup');
  }

  connectedCallback() {

    this.cardItems.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        this.photoGalleryPopup.show(item);
      });
    });

    this.readMoreBtns.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.photoGalleryPopup.show();
      });
    });

    this.swiper = new Swiper(this.swiperContainer, {
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        nextEl: this.querySelector('[data-swiper-button-next]'),
        prevEl: this.querySelector('[data-swiper-button-prev]'),
      },
      pagination: {
        el: this.querySelector('[data-swiper-pagination]'),
        clickable: true,
      },
    });
  }
}
class CustomBlogArticles extends HTMLElement {
  constructor() {
    super();

    this.openVideoBtn = this.querySelector('[data-open-video]');
    this.readMoreBtns = this.querySelectorAll('[data-read-more]');
    this.swiperContainer = this.querySelector('[data-swiper-container]');
    this.cardItems = this.querySelectorAll('[data-card-item]');

  }

  connectedCallback() {

    this.swiper = new Swiper(this.swiperContainer, {
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        nextEl: this.querySelector('[data-swiper-button-next]'),
        prevEl: this.querySelector('[data-swiper-button-prev]'),
      },
      pagination: {
        el: this.querySelector('[data-swiper-pagination]'),
        clickable: true,
      },
    });
  }
}
class CustomSlideRightTextImage extends HTMLElement {
  constructor() {
    super();

    this.openVideoBtn = this.querySelector('[data-open-video]');
    this.readMoreBtns = this.querySelectorAll('[data-read-more]');
    this.swiperContainer = this.querySelector('[data-swiper-container]');
    this.cardItems = this.querySelectorAll('[data-card-item]');

  }

  connectedCallback() {
    const menu = ['Mission', 'Values', 'Scientifically proven formulas']
    this.swiper = new Swiper(this.swiperContainer, {
      spaceBetween: 10,
      effect: 'fade',
      autoHeight: false,
      navigation: {
        nextEl: this.querySelector('[data-swiper-button-next]'),
        prevEl: this.querySelector('[data-swiper-button-prev]'),
      },
      pagination: {
        el: this.querySelector('[data-swiper-pagination]'),
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="${className}">${menu[index]}</span>`
        }
      },
    });
  }
}

class CardVideoCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiperContainer = this.querySelector('[data-swiper-container]');
    this.playBtns = this.querySelectorAll('[data-video-play-button]');
    this.swiperSlides = this.querySelectorAll('[data-swiper-slide]');
  }

  connectedCallback() {
    // initialize the carousel
    const swiper = new Swiper(this.swiperContainer, {
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        nextEl: this.querySelector('[data-swiper-button-next]'),
        prevEl: this.querySelector('[data-swiper-button-prev]'),
      },
      pagination: {
        el: this.querySelector('[data-swiper-pagination]'),
        clickable: true,
      },
    });

    // add event listener to each play button
    this.playBtns.forEach(button => {
      const video = button.closest('.swiper-slide').querySelector('video');
      video.addEventListener('click', () => {
        // pause the video
        if (!video.paused) {
          console.log('video is playing');
          this._pauseVideo(video);
          button.classList.remove('hidden');
        } else {
          console.log('video is paused');
          this._playVideo(video);
          button.classList.add('hidden');
        }
      })

      button.addEventListener('click', () => {
        // get this e parent video element
        if (video) {
          // play the video
          this._playVideo(video);
          // unmute the video
          video.muted = false;
          // hide the play button
          button.classList.add('hidden');
        }
      })
    })

  }

  _pauseAllVideos() {
    this.swiperSlides.forEach(slide => {
      const video = slide.querySelector('video');
      const playBtn = slide.querySelector('[data-video-play-button]');
      if (playBtn) {
        playBtn.classList.remove('hidden');
      }
      if (video) {
        // show the play button
        this._pauseVideo(video);
      }
    });
  }
  _playVideo(video) {
    this._pauseAllVideos();
    video.play();
    video.muted = false;

    const cardContent = video.closest('.video-card-container').querySelector('[data-card-content]');
    if (cardContent) {
      console.log('card content: ', cardContent);
      cardContent.classList.add('hidden');
    }
  }

  _pauseVideo(video) {
    video.pause();
    video.muted = true;

    const cardContent = video.closest('.video-card-container').querySelector('[data-card-content]');
    if (cardContent) {
      cardContent.classList.remove('hidden');
    }
  }
}

class CardListPopup extends HTMLElement {
  constructor() {
    super();

    // declare variables
    this.popupContent = this.querySelector('[data-popup-content]');
    this.closeBtn = this.querySelector('[data-close-popup]');
    this.blankSlate = this.querySelector('[data-blank-slate]');

    // card list popup content
    this.cardListPopupContent = this.querySelector('[data-main-content]');

    this.swiperContainer = this.querySelector('[data-swiper-container]');

    this.swiperSwiperContent = this.querySelector('[data-swiper-content]');

    this.swiperSlides = null;

    this.swiper = null;
    
    // append this to the body
    document.querySelector('body').appendChild(this);
  }

  connectedCallback() {
    // initialize the swiper
    this._initSwiper();

    // add event listener to close button
    this.closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this._hide();
    });

    // add event listener to outside click
    this.blankSlate.addEventListener('click', (e) => {
      e.preventDefault();
      this._hide();
    });

    // add event listener to escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this._hide();
      }
    });
  }

  _initSwiper() {
    if (this.swiper) {
      this.swiper.destroy();
    }
    
    // Check if the carousel contains videos or just images
    const hasVideos = this.swiperSwiperContent.querySelector('video') !== null;
    const slidesPerViewSetting = hasVideos ? "auto" : 1;
    
    // initialize the swiper
    this.swiper = new Swiper(this.swiperContainer, {
      slidesPerView: slidesPerViewSetting,
      spaceBetween: 10,
      navigation: {
        nextEl: this.querySelector('[data-swiper-button-next]'),
        prevEl: this.querySelector('[data-swiper-button-prev]'),
      },
      pagination: {
        el: this.querySelector('[data-swiper-pagination]'),
        clickable: true,
      },
    });
    this.swiperSlides = this.querySelectorAll('[data-swiper-slide]');

    this.playBtns = this.querySelectorAll('[data-video-play-button]');

    // add event listener to each play button
    this.playBtns.forEach(button => {
      const video = button.closest('.swiper-slide').querySelector('video');
      video.addEventListener('click', () => {
        if (!video.paused) {
          console.log('video is playing');
          // play the video
          video.pause();
          // unmute the video
          video.muted = true;
          // hide the play button
          button.classList.remove('hidden');
        } else {
          console.log('video is paused');
          this._playVideo(video);
          video.muted = false;
          // hide the play button
          button.classList.add('hidden');
        }
      })
    })
  }

  _show() {
    document.querySelector('body').style.overflow = 'hidden';
    this.style.display = 'block';
    this.popupContent.animate([
      { clipPath: 'inset(0 0 0 100% round var(--rounded-sm))' }, // Hidden from left
      { clipPath: 'inset(0 0 0 0 round var(--rounded-sm))' }     // Fully visible
    ], {
      duration: 300,
      easing: 'ease-out',
      fill: 'forwards' // Keeps the final state
    }).finished.then(() => {
      this.popupContent.querySelectorAll('[data-option-content]').forEach(content => {
        content.classList.remove('visibility-hidden');
      })
    });
  }

  _pauseAllVideos() {
    this.swiperSlides.forEach(slide => {
      const video = slide.querySelector('video');
      const playBtn = slide.querySelector('[data-video-play-button]');
      if (playBtn) {
        playBtn.classList.remove('hidden');
      }
      if (video) {
        // show the play button
        video.pause();
      }
    });
  }

  _playVideo(video) {
    this._pauseAllVideos();
    video.play();
  }

  _hide() {
    this.popupContent.animate([
      { clipPath: 'inset(0 0 0 0 round var(--rounded-sm))' },     // Fully visible
      { clipPath: 'inset(0 0 0 100% round var(--rounded-sm))' } // Hidden from left
    ], {
      duration: 300,
      easing: 'ease-out',
      fill: 'forwards' // Keeps the final state
    }).finished.then(() => {
      this._pauseAllVideos();
      this.popupContent.querySelectorAll('[data-option-content]').forEach(content => {
        content.classList.add('visibility-hidden');
      })
      document.querySelector('body').style.overflow = 'auto';
      this.style.display = 'none';
    });
  }

  updateContent(content) {
    this.cardListPopupContent.innerHTML = content;
  }

  updateCarouselTitle(title) {
    this.querySelector('[data-carousel-title]').innerHTML = title;
  }

  updateCarouselContent(content) {
    this.swiperSwiperContent.innerHTML = content;

    // reinitialize the swiper
    this._initSwiper();
  }
}

class TextWithPopup extends HTMLElement {
  constructor() {
    super();

    // declare variables
    this.popupContainer = this.querySelector('[data-popup-container]');
    this.popupBlankSlate = this.querySelector('[data-blank-slate]');
    this.popupContent = this.querySelector('[data-popup-content]');
    this.btnReadMore = this.querySelector('[data-read-more]');
    this.btnPopupClose = this.querySelector('[data-close-popup]');

    // append this to the body
    document.querySelector('body').appendChild(this.popupContainer);
  }

  connectedCallback() {
    // add event listener to read more button
    this.btnReadMore.addEventListener('click', (e) => {
      e.preventDefault();
      this._show();
    })
    
    this.popupBlankSlate.addEventListener('click', (e) => {
      e.preventDefault();
      this._hide();
    });

    this.btnPopupClose.addEventListener('click', (e) => {
      e.preventDefault();
      this._hide();
    });
  }

  _show() {
    document.querySelector('body').style.overflow = 'hidden';
    this.popupContainer.style.display = 'block';
    this.popupContent.animate([
      { clipPath: 'inset(0 0 0 100% round var(--rounded-sm))' }, // Hidden from left
      { clipPath: 'inset(0 0 0 0 round var(--rounded-sm))' }     // Fully visible
    ], {
      duration: 300,
      easing: 'ease-out',
      fill: 'forwards' // Keeps the final state
    }).finished.then(() => {
      this.popupContent.querySelectorAll('[data-option-content]').forEach(content => {
        content.classList.remove('visibility-hidden');
      })
    });
  }

  _hide() {
    this.popupContent.animate([
      { clipPath: 'inset(0 0 0 0 round var(--rounded-sm))' },     // Fully visible
      { clipPath: 'inset(0 0 0 100% round var(--rounded-sm))' } // Hidden from left
    ], {
      duration: 300,
      easing: 'ease-out',
      fill: 'forwards' // Keeps the final state
    }).finished.then(() => {
      document.querySelector('body').style.overflow = 'auto';
      this.popupContainer.style.display = 'none';
      this.popupContent.querySelectorAll('[data-option-content]').forEach(content => {
        content.classList.add('visibility-hidden');
      })
    });
  }
}

class InstallationPopup extends HTMLElement {
  constructor() {
    super();

    this.closeBtn = this.querySelector('[data-close-popup]');
    this.playButton = this.querySelector('[data-video-play-button]');

    this.blankSlate = this.querySelector('[data-blank-slate]');

    this.video = this.querySelector('video');
    // append this to the body
    document.querySelector('body').appendChild(this);
  }

  connectedCallback() {
    // add event listener to blank slate
    this.blankSlate.addEventListener('click', (e) => {
      e.preventDefault();
      this._hide();
    });
    
    this.closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this._hide();
    });

    this.playButton.addEventListener('click', (e) => {
      e.preventDefault();
      this._playVideo();
    });

    this.video.addEventListener('click', (e) => {
      e.preventDefault();

      // check if video is playing first
      if (!this.video.paused) {
        this._pauseVideo();
      } else {
        this._playVideo();
      }
    });
  }

  show() {
    this.style.display = 'block';
    document.querySelector('body').style.overflow = 'hidden';
  }
  
  _hide() {
    this.style.display = 'none';
    document.querySelector('body').style.overflow = 'auto';
  }

  _playVideo() {
    // unmute the video
    this.video.muted = false;

    this.video.play();
    this.playButton.classList.add('hidden');
  }

  _pauseVideo() {
    this.video.pause();
    this.playButton.classList.remove('hidden');
  }
}

class CustomCarousel extends HTMLElement {
  constructor() {
    super();

    this.swiperContainer = this.querySelector('[data-swiper-container]');
  }

  connectedCallback() {
    this.swiper = new Swiper(this.swiperContainer, {
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        nextEl: this.querySelector('[data-swiper-button-next]'),
        prevEl: this.querySelector('[data-swiper-button-prev]'),
      },
      pagination: {
        el: this.querySelector('[data-swiper-pagination]'),
        clickable: true,
      },
    });

    console.log('Custom carousel initialized');
  }
}
class CustomCarouselV3 extends HTMLElement {
  constructor() {
    super();

    this.swiperContainer = this.querySelector('[data-swiper-container]');
  }

  connectedCallback() {
    this.swiper = new Swiper(this.swiperContainer, {
      slidesPerView: "auto",
      loop: true,
      spaceBetween: 10,
      navigation: {
        nextEl: this.querySelector('[data-swiper-button-next]'),
        prevEl: this.querySelector('[data-swiper-button-prev]'),
      },
      pagination: {
        el: this.querySelector('[data-swiper-pagination]'),
        clickable: true,
      },
    });

    console.log('Custom carousel initialized');
  }
}

class CustomMediaGrid extends HTMLElement {
  constructor() {
    super();

    this.videos = this.querySelectorAll('video');
    this.playBtns = this.querySelectorAll('[data-video-play-button]');
    this.showMoreBtn = this.querySelector('[data-show-more]');
  }

  connectedCallback() {
    this.playBtns.forEach(button => {
      const video = button.closest('.media-grid__item').querySelector('video');
      button.addEventListener('click', () => {
        this._playVideo(video);
        button.classList.add('hidden');
      })
    })

    this.videos.forEach(video => {
      video.addEventListener('click', () => {
        if (!video.paused) {
          this._pauseVideo(video);
          const playBtn = video.closest('.media-grid__item').querySelector('[data-video-play-button]');
          if (playBtn) {
            playBtn.classList.remove('hidden');
          }
        } else {
          this._playVideo(video);
          const playBtn = video.closest('.media-grid__item').querySelector('[data-video-play-button]');
          if (playBtn) {
            playBtn.classList.add('hidden');
          }
        }
      })
    })

    this.showMoreBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this._showMoreGrid();

      // hide the show more button
      this.showMoreBtn.classList.add('hidden');
    }
    )
  }
  
  _showMoreGrid() {
    this.querySelectorAll('.media-grid__item').forEach(item => {
      item.classList.remove('hidden-init-mobile');
    })
  }

  _playVideo(video) {
    this._pauseAllVideos();
    video.play();
    video.muted = false;
  }

  _pauseVideo(video) {
    video.pause();
    video.muted = true;
  }

  _pauseAllVideos() {
    this.videos.forEach(video => {
      this._pauseVideo(video);
      const playBtn = video.closest('.media-grid__item').querySelector('[data-video-play-button]');
      if (playBtn) {
        playBtn.classList.remove('hidden');
      }
    });
  }
} 

class CustomFreeCartItemBar extends HTMLElement {
  constructor() {
    super(); 
    this.cartItemsQty = 0;
    this.shippingItems = this.querySelectorAll('[data-cart-shipping-item]');
    this.progress = this.querySelector('[data-progress]');
  }

  connectedCallback() {
    // this._fetchCartQty();
    
  }

  _fetchCartQty() {
    // fetch cart items from the cart API
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        this.cartItemsQty = data.item_count;
        this.shippingItems.forEach(item => {
          const itemCartAmount = item.getAttribute('data-cart-amount');
          const itemProgress = item.getAttribute('data-cart-progress');
          console.log('item cart amount: ', this.cartItemsQty);
          console.log('item item count: ', itemCartAmount);

          if (Number(this.cartItemsQty) >= Number(itemCartAmount)) {
            console.log('item cart amount is greater than or equal to cart items');
            this.progress.style.width = itemProgress + '%';
            item.classList.add('active');

            const itemVariantId = item.getAttribute('data-cart-variant-id');
            if (itemVariantId) {
              console.log('item variant id: ', itemVariantId);
              this._fetchCartItems(itemVariantId);
            }
          }
        })
      })
      .catch(error => console.error('Error fetching cart items:', error));
  }
  _fetchCartItems(variantId) {
    // fetch cart items from the cart API
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        const cartItems = data.items.filter(item => item.variant_id === Number(variantId));
        console.log('Cart items fetched: ', cartItems);

        if(cartItems.length == 0) {
          //add to cart variantId
          fetch(`/cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1
              }]
            })
          })
          .then(response => response.json())
          .then(data => {
            console.log('Cart updated successfully:', data);
            // Optionally, you can update the UI or notify the user
          })
          .catch(error => console.error('Error updating cart:', error));
        }
      })
      .catch(error => console.error('Error fetching cart items:', error));
  }
}

class CustomLineItemQuantity extends HTMLElement {
  constructor() {
   super();
   
   this.quantityActionBtns = this.querySelectorAll('[data-quantity-action]');
  }
  
  connectedCallback() {
    let changeTimeout;
    // add event listener to each quantity action button
    this.quantityActionBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const action = btn.dataset.quantityAction;
        const input = btn.closest('.line-item__info-container').querySelector('input');
        let currentQty = parseInt(input.value, 10);
        
        if (action === 'increment') {
          currentQty++;
        } else if (action === 'decrement' && currentQty > 1) {
          currentQty--;
        }

        if (input.value == currentQty) {
          return; // no change in quantity
        }

        input.value = currentQty;
        // debounce
        clearTimeout(changeTimeout);

        changeTimeout = setTimeout(() => {
          // perform change event on input
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }, 300)
      });
    });
  }

}

class CustomQuickBuy extends HTMLElement {
  constructor() {
    super();

    this.swiperContainer = this.querySelector('[data-swiper-container]');
    this.popupCloseBtn = this.querySelector('[data-close-popup]');
  }

  connectedCallback() {
    this.swiper = new Swiper(this.swiperContainer, {
      slidesPerView: 2,
      spaceBetween: 10,
      navigation: {
        nextEl: this.querySelector('[data-swiper-button-next]'),
        prevEl: this.querySelector('[data-swiper-button-prev]')
      }
    })

    this.popupCloseBtn.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelectorAll('quick-buy-drawer').forEach((el) => {
        el.removeAttribute('open');
      });
    })
  }
}

class CustomTwoTextBlock extends HTMLElement {
  constructor() {
    super();

    this.values = this.querySelectorAll('[data-value]');
  }

  connectedCallback() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.values.forEach(value => {
            const val = value.dataset.value;
            let count = value.dataset.starting || 0;
            const interval = setInterval(() => {
              count++;
              value.innerHTML = count + '+';
              if (count >= val) {
                clearInterval(interval);
                value.innerHTML = val + '+';
              }
            }, 4); // adjust the speed of the count up effect
            // once the count is complete, we can just set the value to the data-value
            observer.unobserve(this);
          }
          );
        }
      })
    })

    observer.observe(this);
  }
}

class PhotoGalleryPopup extends HTMLElement {
  constructor() {
    super();

    this.blankSlate = this.querySelector('[data-blank-slate]');
    this.popupContent = this.querySelector('[data-popup-content]');
    this.closeBtn = this.querySelector('[data-close-popup]');

    // append this to the body
    document.querySelector('body').appendChild(this);
  }

  connectedCallback() {
    // add event listener to outside click
    this.blankSlate.addEventListener('click', (e) => {
      e.preventDefault();
      this._hide();
    });

    this.closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this._hide();
    });
  }

  show() {
    document.querySelector('body').style.overflow = 'hidden';
    this.style.display = 'block';

    this.popupContent.animate([
      { clipPath: 'inset(0 0 0 100% round var(--rounded-sm))' }, // Hidden from left
      { clipPath: 'inset(0 0 0 0 round var(--rounded-sm))' }     // Fully visible
    ], {
      duration: 300,
      easing: 'ease-out',
      fill: 'forwards' // Keeps the final state
    }).finished.then(() => {
      this.popupContent.querySelectorAll('[data-main-content]').forEach(content => {
        content.classList.remove('visibility-hidden');
      })
    });
  }

  _hide() {
    this.popupContent.animate([
      { clipPath: 'inset(0 0 0 0 round var(--rounded-sm))' },     // Fully visible
      { clipPath: 'inset(0 0 0 100% round var(--rounded-sm))' } // Hidden from left
    ], {
      duration: 300,
      easing: 'ease-out',
      fill: 'forwards' // Keeps the final state
    }).finished.then(() => {
      
      this.popupContent.querySelectorAll('[data-main-content]').forEach(content => {
        content.classList.add('visibility-hidden');
      })
      document.querySelector('body').style.overflow = 'auto';
      this.style.display = 'none';
    });
  }
}

class SubscriptionInput extends HTMLElement {
  constructor() {
    super();

    this.subscriptionInput = this.querySelector('[data-subscription-input]');
    this.subscriptionPopup = document.querySelector('filter-subscription-popup');
    this.subscriptionPopupBtn = this.querySelector('[data-subscription-popup-trigger]');
  }

  connectedCallback() {
    this.subscriptionPopupBtn.addEventListener('click', (e) => {
      e.preventDefault();
      // show the subscription popup
      this.subscriptionPopup.show();
    });

    this.subscriptionInput.addEventListener('change', (e) => {
      // check if the input is checked
      const isChecked = e.target.checked;
      if (isChecked) {
        this.querySelector('.subscription-offer').classList.add('active');
        const id = window.filterVariantID || 47758049968425;
        const sellingPlan = window.filterSellingPlanInput || 692770439465;
        const url = `/cart/change.js?id=${id}&selling_plan=${sellingPlan}`;

        fetch(url, { method: "POST" })
          .then((response) => {
          return response.json();
        })
        .then((data) => {
          const cartRefreshEvent = new CustomEvent("cart:refresh");
          document.dispatchEvent(cartRefreshEvent);
        })
        .catch((error) => {
          alert("Udsolgt")
          console.error("Error:", error);
        });
      } else {
        this.querySelector('.subscription-offer').classList.add('active');
        const id = window.filterVariantID || 47758049968425;
        const sellingPlan = "null";
        const url = `/cart/change.js?id=${id}&selling_plan`;

        fetch(url, { method: "POST" })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          const cartRefreshEvent = new CustomEvent("cart:refresh");
          document.dispatchEvent(cartRefreshEvent);
        })
        .catch((error) => {
          alert("Udsolgt")
          console.error("Error:", error);
        });
      }
    })
  }
}

class FilterSubscriptionPopup extends HTMLElement {
  constructor() {
    super();

    this.blankSlate = this.querySelector('[data-blank-slate]');
    this.popupContent = this.querySelector('[data-popup-content]');
    this.closeBtns = this.querySelectorAll('[data-close-popup]');

    // append this to the body
    document.querySelector('body').appendChild(this);
  }

  connectedCallback() {

    this.closeBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this._hide();
      }
      );
    });

    this.blankSlate.addEventListener('click', (e) => {
      e.preventDefault();
      this._hide();
    });
  }

  show() {
    document.querySelector('body').style.overflow = 'hidden';
    this.style.display = 'block';
  }

  _hide() {
    document.querySelector('body').style.overflow = 'auto';
    this.style.display = 'none';
  }
}

class CustomBarGraph extends HTMLElement {
  constructor() {
    super();
    this.selectedOption = this.querySelector('[data-select-option]');
    this.barGraph1 = this.querySelector('[data-graph-1]');
    this.barGraph2 = this.querySelector('[data-graph-2]');
    this.graphs = this.querySelectorAll('[data-graph]');
    this.graphContainer = this.querySelector('[data-graph-container]');
    this.graphInContainer = this.querySelector('[data-graph-inner-container]');
    this.metric = this.querySelector('[data-metric]');
  }

  connectedCallback() {
    this.selectedOption?.addEventListener('change', (e) => {
      const selectedValue = e.target.value;
      console.log('selected value: ', selectedValue);
      // split the selected value by |
      const values = selectedValue.split('|');
      // set bargraph 1 height
      if (values[0]) {
        const maxValue = parseFloat(values[3]) || 100; // default to 100 if not provided
        const height1 = this._calculateGraphHeight(parseFloat(values[0]), maxValue);
        console.log('height: ', height1);
        this.barGraph1.style.height = height1 + '%';
        this.barGraph1.dataset.width = height1;
      }

      // set bargraph 2 height
      if (values[1]) {
        const maxValue = parseFloat(values[3]) || 100; // default to 100 if not provided
        const height2 = this._calculateGraphHeight(parseFloat(values[1]), maxValue);
        console.log('height: ', height2);
        this.barGraph2.style.height =height2 + '%';
        this.barGraph2.dataset.width = height2;
      }

      if (values[2]) {
        this.metric.innerHTML = values[2];
      }

      if( values[3]) {
        const genScale = this._generateScale(values[3]);
        console.log("value 3: ", genScale);
        // remove all existing scale items from this.graphInContainer which have the selector [data-graph-scale]
        this.graphInContainer.querySelectorAll('[data-graph-scale]').forEach(item => {
          item.remove();
        });
        // generate scale items
        genScale.forEach((scaleValue, index) => {
          const scaleItem = document.createElement('div');
          scaleItem.classList.add('grph-ln-itm');
          scaleItem.setAttribute('data-graph-scale', '');
          scaleItem.setAttribute('data-value', scaleValue);
          this.graphInContainer.appendChild(scaleItem);
        });

      }

    })

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.graphs.forEach(graph => {
            graph.style.height = graph.dataset.width + '%';
          })
        }
      })
    })

    // observe the graph container
    observer.observe(this.graphContainer);
  }

  _generateScale(maxValueStr) {
    const steps = 5;
    const maxValue = parseFloat(maxValueStr); // convert string to number
    const stepSize = maxValue / steps;

    const isFloat = stepSize % 1 !== 0;

    const scale = [];
    for (let i = 0; i <= steps; i++) {
      const value = maxValue - i * stepSize;

      if (isFloat) {
        // Detect precision from step size
        const decimals = stepSize.toString().split('.')[1]?.length || 1;
        scale.push(parseFloat(value.toFixed(decimals)));
      } else {
        scale.push(Math.round(value));
      }
    }

    return scale;
  }

  _calculateGraphHeight(value, maxValue) {
    if (maxValue === 0) return 0; // Avoid division by zero
    const height = (value / maxValue) * 100; // Calculate height as a percentage
    return Math.min(Math.max(height, 0), 100); // Ensure height is between 0 and 100
  }
}

document.addEventListener('DOMContentLoaded', function () {

  // Theme exposed hooks
  document.addEventListener('variant:change', function() {
    const selectedVariant = event.detail?.variant;

    const colorValue = selectedVariant?.option1.toLowerCase() || '';
    const featuredImage = selectedVariant?.featured_image.src || '';

    console.log('Variant changed: ', selectedVariant);
    if (!colorValue) return;
    console.log('featured image: ', featuredImage);
    if(featuredImage) {
      const featuredImageElement = document.querySelector('.product-featured-image img');
      if (featuredImageElement) {
        featuredImageElement.src = featuredImage;
        featuredImageElement.srcset = `${featuredImage};width=200 200w, ${featuredImage};width=300 300w, ${featuredImage};width=400 400w, ${featuredImage};width=500 500w, ${featuredImage};width=600 600w, ${featuredImage};width=700 700w, ${featuredImage};width=800 800w, ${featuredImage};width=1000 1000w, ${featuredImage};width=1200 1200w, ${featuredImage};width=1400 1400w, ${featuredImage};width=1600 1600w, ${featuredImage};width=1800 1800w`;
        console.log('featured image element: ', featuredImageElement);
      }
    }

    const galleryImages = document.querySelectorAll('[data-color-value]');
  
    galleryImages.forEach(image => {
      const thisColorValue = image.dataset.colorValue.toLowerCase();
      if (thisColorValue === colorValue) {
        image.removeAttribute('hidden');
      } else if (thisColorValue != '' && !image.classList.contains('product-featured-image')) {
        image.setAttribute('hidden', 'true');
      }
    });


  });

  document.dispatchEvent(new CustomEvent('variant:change'));

  customElements.define('product-collection-filter', ProductCollectionFilter);
  customElements.define('change-frequency-popup', ChangeFrequencyPopup);
  customElements.define('custom-product-options', CustomProductOptions);
  customElements.define('custom-product-options-subscribe-one-time', CustomProductOptionsSubscribeOneTime);
  customElements.define('custom-image-with-grid', CustomImageWithGrid);
  customElements.define('card-list-popup', CardListPopup);
  customElements.define('card-video-carousel', CardVideoCarousel);
  customElements.define('text-with-popup', TextWithPopup);
  customElements.define('installation-popup', InstallationPopup);
  customElements.define('custom-installation-card', CustomInstallationCard);
  customElements.define('custom-carousel', CustomCarousel);
  customElements.define('custom-carousel-v3', CustomCarouselV3);
  customElements.define('custom-media-grid', CustomMediaGrid);
  customElements.define('custom-free-cart-item-bar', CustomFreeCartItemBar);
  customElements.define('custom-line-item-quantity', CustomLineItemQuantity);
  customElements.define('custom-quick-buy', CustomQuickBuy);
  customElements.define('custom-two-text-block', CustomTwoTextBlock);
  customElements.define('custom-photo-gallery', CustomPhotoGallery);
  customElements.define('custom-blog-articles', CustomBlogArticles);
  customElements.define('photo-gallery-popup', PhotoGalleryPopup);
  customElements.define('custom-slide-right-text-image', CustomSlideRightTextImage);
  customElements.define('subscription-input', SubscriptionInput);
  customElements.define('filter-subscription-popup', FilterSubscriptionPopup);
  customElements.define('custom-bar-graph', CustomBarGraph);
});



// Threshold bar interactions (moved from snippet)
function tbConvertToDanishPrice(price) {
  var formattedPrice = (price / 100).toFixed(2).replace('.', ',');
  return formattedPrice + ' kr.';
}

function onTBChange(e) {
  if (e.target.tagName !== 'SELECT') return;
  var item = e.target.closest('.tb-card');
  if (!item) return;
  try {
    var product = JSON.parse(item.getAttribute('data-product'));
    var selects = Array.from(item.querySelectorAll('select'));
    var selectedOptions = selects.map(function(select) { return select.value; });
    var selectedVariant = product.variants.find(function(variant) {
      return variant.options.every(function(opt, idx) { return opt === selectedOptions[idx]; });
    });
    if (!selectedVariant) return;

    item.setAttribute('data-selected-variant', selectedVariant.id);

    var variantImgs = item.querySelectorAll('.tb-variant-image');
    variantImgs.forEach(function(img) {
      img.classList.remove('active');
      if (String(img.getAttribute('data-id')) === String(selectedVariant.id)) {
        img.classList.add('active');
      }
    });

    var cta = item.querySelector('.tb-add-to-cart');
    if (cta) {
      if (selectedVariant.available) {
        cta.classList.remove('disabled');
        var addToCartText = cta.getAttribute('data-add-to-cart-text') || 'Tilføj til kurv';
        cta.textContent = addToCartText + ' · ' + tbConvertToDanishPrice(0);
      } else {
        cta.classList.add('disabled');
        cta.textContent = 'Udsolgt';
      }
    }

    var selectedOption = e.target.options[e.target.selectedIndex];
    var colorHex = selectedOption.getAttribute('data-value');
    var colorIndicator = e.target.parentElement.querySelector('.tb-color-indicator');
    if (colorIndicator) {
      colorIndicator.style.backgroundColor = colorHex || 'transparent';
    }
  } catch (err) {
    console.error(err);
  }
}

async function onTBAddToCart(e) {
  var ctaEl = e.target.closest('.tb-add-to-cart');
  if (!ctaEl) return;
  var item = ctaEl.closest('.tb-card');
  if (!item) return;
  try {
    var product = JSON.parse(item.getAttribute('data-product'));
    var selects = Array.from(item.querySelectorAll('select'));
    var selectedOptions = selects.map(function(select) { return select.value; });
    var selectedVariant = product.variants.find(function(variant) {
      return variant.options.every(function(opt, idx) { return opt === selectedOptions[idx]; });
    });
    if (!selectedVariant) {
      var preselectedId = item.getAttribute('data-selected-variant');
      if (preselectedId) {
        selectedVariant = product.variants.find(function(v) { return String(v.id) === String(preselectedId); });
      }
      if (!selectedVariant) {
        selectedVariant = product.variants[0];
      }
    }
    if (!selectedVariant) return;

    var itemsToAdd = [{ id: selectedVariant.id, quantity: 1 }];
    var sectionsToBundle = ['variant-added'];

    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

    var resp = await fetch(Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: itemsToAdd, sections: sectionsToBundle.join(',') })
    });
    var responseJson = await resp.json();
    if (resp.status === 200) {
      var cartContent = await (await fetch(Shopify.routes.root + 'cart.js')).json();
      cartContent['sections'] = responseJson['sections'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cartContent } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cartContent } }));
    }
  } catch (err) {
    console.error(err);
  }
}

// Delegated listeners on document to survive re-renders
document.addEventListener('change', function(e) {
  if (!e.target.closest('.tb-recommendation-container')) return;
  onTBChange(e);
});

document.addEventListener('click', function(e) {
  if (!e.target.closest('.tb-recommendation-container')) return;
  onTBAddToCart(e);
});

// Preload variant images when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  var tbContainer = document.querySelector('.tb-recommendation-container');
  if (!tbContainer) return;
  var items = tbContainer.querySelectorAll('.tb-card');
  items.forEach(function(li) {
    try {
      var product = JSON.parse(li.getAttribute('data-product'));
      (product.variants || []).forEach(function(v) {
        if (v.featured_image && v.featured_image.src) {
          var img = new Image();
          img.src = v.featured_image.src;
        }
      });
    } catch (e) {}
  });
});




// Threshold gifts auto-removal when going below thresholds
(function() {
function getThresholdHost() {
  return document.querySelector('custom-free-cart-item-bar');
}

async function fetchCartJson() {
  try { return await (await fetch(`${Shopify.routes.root}cart.js`)).json(); } catch(e) { return null; }
}

function getHostData() {
  var host = getThresholdHost();
  if (!host) return null;
  return {
    freeShippingThreshold: Number(host.getAttribute('data-free-shipping-threshold')) || 0,
    secondThreshold: Number(host.getAttribute('data-second-threshold')) || 0,
    giftCardThreshold: Number(host.getAttribute('data-gift-card-threshold')) || 0,
    // Note: these attributes hold PRODUCT IDs (not variant IDs)
    freeGiftProductId: host.getAttribute('data-free-shipping-variant-id'),
    secondGiftProductId: host.getAttribute('data-second-variant-id'),
    giftCardProductId: host.getAttribute('data-gift-card-variant-id')
  };
}

function buildRemovalPolicy(data, cartTotal) {
  var productIds = [];
  var tags = [];
  if (!data) return { productIds: productIds, tags: tags };
  // Below gift card threshold -> remove gift_card
  if (data.giftCardProductId && cartTotal < data.giftCardThreshold) {
    productIds.push(String(data.giftCardProductId));
    tags.push('gift_card');
  }
  // Below second threshold -> remove second (and also gift_card, already handled above)
  if (data.secondGiftProductId && cartTotal < data.secondThreshold) {
    productIds.push(String(data.secondGiftProductId));
    tags.push('second');
  }
  // Below free shipping threshold -> remove free_shipping (and also others, already handled above)
  if (data.freeGiftProductId && cartTotal < data.freeShippingThreshold) {
    productIds.push(String(data.freeGiftProductId));
    tags.push('free_shipping');
  }
  return { productIds: productIds, tags: tags };
}

async function removeGiftsIfNeeded(cart) {
  var hostData = getHostData();
  if (!hostData) return;
  var cartTotal = (cart && typeof cart.total_price === 'number') ? cart.total_price : 0;
  var policy = buildRemovalPolicy(hostData, cartTotal);
  if (policy.productIds.length === 0 && policy.tags.length === 0) return;

  // Collect line item updates: set quantity 0 for any line whose variant id matches a gift that should be removed
  var updates = {};
  (cart.items || []).forEach(function(item) {
    var vId = String(item.id);
    var pId = String(item.product_id);
    var isTaggedGift = false;
    try {
      var props = item.properties || {};
      var tag = props['thresholdGift'] || props.thresholdGift;
      if (tag && policy.tags.indexOf(String(tag)) !== -1) isTaggedGift = true;
    } catch (_) {}
    if (policy.productIds.indexOf(pId) !== -1 || isTaggedGift) updates[vId] = 0;
  });
  var updateIds = Object.keys(updates);
  if (updateIds.length === 0) return;

  try {
    var resp = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    });
    var updatedCart = await resp.json();
    if (resp.status === 200) {
      // Re-dispatch cart change/refresh so drawer UI updates immediately
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:remove', cart: updatedCart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: updatedCart } }));
    }
  } catch (e) { console.error(e); }
}

// Hook into cart events and also run on DOM ready
// Use Impact theme events per docs
document.addEventListener('cart:change', function(e) {
  var cart = e && e.detail && e.detail.cart ? e.detail.cart : null;
  if (cart) removeGiftsIfNeeded(cart);
});

document.addEventListener('variant:add', function(e) {
  var cart = e && e.detail && e.detail.cart ? e.detail.cart : null;
  if (cart) removeGiftsIfNeeded(cart);
});

document.addEventListener('line-item:change', function(e) {
  var cart = e && e.detail && e.detail.cart ? e.detail.cart : null;
  if (cart) removeGiftsIfNeeded(cart);
});

document.addEventListener('cart:refresh', async function() {
  var cart = await fetchCartJson();
  if (cart) removeGiftsIfNeeded(cart);
});

document.addEventListener('DOMContentLoaded', async function() {
  var cart = await fetchCartJson();
  if (cart) removeGiftsIfNeeded(cart);
});
})();



// Shipping insurance: add item before checkout if checkbox selected
(function() {
  var isProcessingInsurance = false;

  function getShippingInsuranceCheckbox() {
      return document.getElementById('shipping-insurance');
  }

  function getInsuranceId() {
      var el = getShippingInsuranceCheckbox();
      if (!el) return null;
      var raw = el.getAttribute('data-product-id');
      if (!raw) return null;
      // Normalize to numeric string (theme may pass numeric as string)
      return String(raw).replace(/[^0-9]/g, '');
  }

  async function getCartJson() {
      try {
          var resp = await fetch(Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } });
          return await resp.json();
      } catch (_) {
          return null;
      }
  }

  async function syncInsuranceCheckboxWithCart(cart) {
      try {
          var checkbox = getShippingInsuranceCheckbox();
          if (!checkbox) return;
          var insuranceId = getInsuranceId();
          if (!insuranceId) return;

          var currentCart = cart;
          if (!currentCart) {
              currentCart = await getCartJson();
          }
          if (!currentCart) return;

          var present = Array.isArray(currentCart.items) && currentCart.items.some(function(item) {
              return String(item.id) === String(insuranceId) || String(item.product_id) === String(insuranceId);
          });
          checkbox.checked = !!present;
      } catch (_) {}
  }

  async function addInsuranceIfNeeded() {
      var checkbox = getShippingInsuranceCheckbox();
      if (!checkbox || !checkbox.checked) return { handled: false };

      var insuranceId = getInsuranceId();
      if (!insuranceId) return { handled: false };

      if (isProcessingInsurance) return { handled: true };
      isProcessingInsurance = true;
      try {
          var cart = await getCartJson();
          var alreadyInCart = false;
          try {
              alreadyInCart = Array.isArray(cart && cart.items) && cart.items.some(function(item) {
                  return String(item.id) === String(insuranceId) || String(item.product_id) === String(insuranceId);
              });
          } catch (_) {}

          if (alreadyInCart) {
              return { handled: true, added: false };
          }

          try {
              var addResp = await fetch(Shopify.routes.root + 'cart/add.js', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                      'Accept': 'application/json',
                      'X-Requested-With': 'XMLHttpRequest'
                  },
                  body: JSON.stringify({
                      items: [ { id: Number(insuranceId), quantity: 1 } ]
                  })
              });
              var addedOk = !!(addResp && addResp.ok);
              var updatedCart = null;
              try {
                  updatedCart = await (await fetch(Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })).json();
              } catch (_) {}
              if (addedOk && updatedCart) {
                  document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: updatedCart } }));
                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: updatedCart } }));
                  try { checkbox.checked = true; } catch (_) {}
                  try { syncInsuranceCheckboxWithCart(updatedCart); } catch (_) {}
                  return { handled: true, added: true };
              }
          } catch (_) {}

          return { handled: true, added: false };
      } finally {
          isProcessingInsurance = false;
      }
  }

  async function removeInsuranceIfPresent() {
      var insuranceId = getInsuranceId();
      if (!insuranceId) return { handled: false };

      if (isProcessingInsurance) return { handled: true };
      isProcessingInsurance = true;
      try {
          var cart = await getCartJson();
          var present = false;
          try {
              present = Array.isArray(cart && cart.items) && cart.items.some(function(item) {
                  return String(item.id) === String(insuranceId) || String(item.product_id) === String(insuranceId);
              });
          } catch (_) {}

          if (!present) {
              return { handled: true, removed: false };
          }

          try {
              var resp = await fetch(Shopify.routes.root + 'cart/update.js', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                      'Accept': 'application/json',
                      'X-Requested-With': 'XMLHttpRequest'
                  },
                  body: JSON.stringify({ updates: (function(){ var u = {}; u[String(insuranceId)] = 0; return u; })() })
              });
              var updatedCart = null;
              try {
                  updatedCart = await resp.json();
              } catch (_) {}
              if (resp && resp.status === 200 && updatedCart) {
                  document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:remove', cart: updatedCart } }));
                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: updatedCart } }));
                  try { var cb = getShippingInsuranceCheckbox(); if (cb) cb.checked = false; } catch (_) {}
                  try { syncInsuranceCheckboxWithCart(updatedCart); } catch (_) {}
                  return { handled: true, removed: true };
              }
          } catch (_) {}

          return { handled: true, removed: false };
      } finally {
          isProcessingInsurance = false;
      }
  }

  // Toggle add/remove on checkbox change (delegated for drawer re-renders)
  document.addEventListener('change', function(e) {
      var target = e && e.target ? e.target : null;
      if (!target || target.id !== 'shipping-insurance') return;

      // Prevent rapid double toggles
      try { target.disabled = true; } catch (_) {}
      var action = target.checked ? addInsuranceIfNeeded() : removeInsuranceIfPresent();
      Promise.resolve(action).finally(function() {
          var cb = getShippingInsuranceCheckbox();
          if (cb) { try { cb.disabled = false; } catch (_) {} }
      });
  }, true);

  // Keep checkbox state in sync with cart contents
  document.addEventListener('DOMContentLoaded', function() {
      syncInsuranceCheckboxWithCart();
  });

  document.addEventListener('cart:change', function(e) {
      var cart = e && e.detail && e.detail.cart ? e.detail.cart : null;
      syncInsuranceCheckboxWithCart(cart);
  });

  document.addEventListener('line-item:change', function(e) {
      var cart = e && e.detail && e.detail.cart ? e.detail.cart : null;
      syncInsuranceCheckboxWithCart(cart);
  });

  document.addEventListener('variant:add', function(e) {
      var cart = e && e.detail && e.detail.cart ? e.detail.cart : null;
      syncInsuranceCheckboxWithCart(cart);
  });

  document.addEventListener('cart:refresh', function() {
      // cart drawer re-renders; fetch fresh cart and sync
      syncInsuranceCheckboxWithCart();
  });
})();

